var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{style:({ height: _vm.fileSize, width: _vm.fileSize })},[(_vm.type == 'image')?_c('el-image',{staticClass:"image",attrs:{"src":_vm.uri}}):(_vm.type == 'video')?_c('video',{attrs:{"src":_vm.uri}}):_vm._e(),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }